<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :span="1">
        </el-col>
        <el-col :span="19">
          <div class="title">青海省中小企业诉求意见及保障支付受理平台</div>
        </el-col>
        <el-col :span="1" style="text-align: right">
          <el-badge :hidden="notifyHandle" is-dot style="margin-top: 10px;cursor: pointer">
            <img @click="handleNotify" src="../assets/ic_notify.png" style="height: 30px;"/>
          </el-badge>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-dropdown @command="handleDropDwonCommand">
            <span class="el-dropdown-link">{{user.name}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="modify_pass">修改密码</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <el-col :span="1" style="text-align: right">
          <img @click="handleLogout" src="../assets/ic_logout.png" style="height: 30px;margin-top: 15px;cursor: pointer"/>
        </el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-aside width="160px">
        <el-menu
          router
          :default-active="$route.path"
          :default-openeds="['appeal','asure','area','publish']"
          style="font-weight:800">
          <el-menu-item index="/statics">
            <i class="el-icon-s-home"></i>
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="appeal">
            <template slot="title">
              <i class="el-icon-receiving"></i>
              <span slot="title">诉求意见</span>
            </template>
            <el-menu-item index="/appeal-wait">
              <i class="el-icon-menu"></i>
              <span slot="title">待办事项</span>
            </el-menu-item>
            <el-menu-item index="/appeal-history">
              <i class="el-icon-menu"></i>
              <span slot="title">处理历史</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="asure">
            <template slot="title">
              <i class="el-icon-money"></i>
              <span slot="title">保障支付</span>
            </template>
            <el-menu-item index="/asure-wait">
              <i class="el-icon-menu"></i>
              <span slot="title">待办事项</span>
            </el-menu-item>
            <el-menu-item index="/asure-history">
              <i class="el-icon-menu"></i>
              <span slot="title">处理历史</span>
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-if="user.role==='admin'" index="/appeal-manage">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">诉求管理</span>
          </el-menu-item>
          <el-menu-item index="/appeal-delay">
            <i class="el-icon-notebook-2"></i>
            <span slot="title">延期审核</span>
          </el-menu-item>
          <el-menu-item v-if="user.role==='admin'" index="/user">
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-submenu v-if="user.role==='admin'" index="area">
            <template slot="title">
              <i class="el-icon-office-building"></i>
              <span slot="title">机构管理</span>
            </template>
            <el-menu-item index="/org">
              <i class="el-icon-menu"></i>
              <span slot="title">单位机构</span>
            </el-menu-item>
            <el-menu-item index="/park">
              <i class="el-icon-menu"></i>
              <span slot="title">地区园区</span>
            </el-menu-item>
          </el-submenu>
          <el-submenu v-if="user.role==='admin'" index="publish">
            <template slot="title">
              <i class="el-icon-s-promotion"></i>
              <span slot="title">发布管理</span>
            </template>
            <el-menu-item index="/publish">
              <i class="el-icon-menu"></i>
              <span slot="title">工作动态</span>
            </el-menu-item>
            <el-menu-item index="/notify">
              <i class="el-icon-menu"></i>
              <span slot="title">通知文件</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
    <el-dialog title="修改密码" :visible.sync="passInfoVisible" :close-on-click-modal="false">
      <el-form :model="passInfo" ref="passForm" :rules="rules">
        <el-form-item label="新密码" type="password" label-width="80px" prop="newPass">
          <el-input type="password" v-model="passInfo.newPass"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" type="password" label-width="80px" prop="confrmPass">
          <el-input type="password" v-model="passInfo.confrmPass"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveNewPass">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
  import md5 from 'js-md5'
  import Common from '@/components/common/Common'
  import { currentUser, logout, resetPwd, enterpriseAppealNotify } from '@/api/restapi.js'
  export default {
    data () {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.passInfo.newPass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        user: {
          auth: []
        },
        notifyHandle: true,
        handleType: '',
        passInfoVisible: false,
        rules: {
          newPass: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          confrmPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        },
        passInfo: {}
      }
    },
    mounted () {
      currentUser().then(res => {
        if (res.data.code === 0) {
          this.user = res.data.data
          Common.user = res.data.data
        }else if (res.data.code === 4001) {
          this.$router.push({path: '/login'})
        }
      })
      enterpriseAppealNotify().then(res => {
        if (res.data.code === 0) {
          this.notifyHandle = false
          this.handleType = res.data.data
        }
      })
    },
    methods: {
      handleDropDwonCommand (command) {
        switch (command) {
          case 'logout':
            this.handleLogout()
            break
          case 'modify_pass':
            this.handleModifyPass()
            break
        }
      },
      handleLogout () {
        logout().then(res => {
          this.$router.push({path: '/login'})
        }).catch(err => {
          console.log(err)
        })
      },
      handleModifyPass () {
        this.passInfoVisible = true
      },
      handleNotify () {
        if (this.handleType === 'opinion') {
          this.$router.push('/appeal-wait')
        }
        if (this.handleType === 'pay') {
          this.$router.push('/asure-wait')
        }
      },
      saveNewPass () {
        let isValid = true
        this.$refs['passForm'].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          return
        }
        resetPwd(md5(this.passInfo.newPass)).then(res => {
          if (res.data.code === 0) {
            this.passInfoVisible = false
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '密码修改失败',
            type: 'error'
          })
          console.log(err)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-header {
    background-color: #07438A;
    color: #FFFFFF;
    line-height: 60px;
    height: 60px;
    font-weight: bold;
  }
  .el-badge >>> .is-dot  {
    top: 5px;
  }
  .el-container {
    height: 100%;
    background-color: #FFFFFF;
    overflow: auto;
  }
  .el-aside {
    height: 100%;
    background: white;
  }
  .el-main {
    padding: 10px;
    background:#F3F3F5;
  }
  .title {
    font-size: 25px;
  }
  .el-dropdown {
    float: right;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 15px;
    color: #FFFFFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .el-menu{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue